import {
    ChartOfAccountsTemplateAccountsBulkSave,
    TemplateAccountGroupInput,
    TemplateAccountInput,
} from "@common/schemas/chart-of-accounts-template-account.schema";
import { DraftState } from "../draftOperations";
import {
    NULL_TEMPLATE_IDENTITY,
    TemplateAccountIdentity,
} from "./templateDraftMapping";

// Maps the host-agnostic draft state back into the template bulk-save payload:
// variableKind / kickOriginalCode come from the host's side map (or the null default for a freshly-created row); form1099Box is user-editable, so it comes from the draft.
export const toTemplateBulkSavePayload = ({
    state,
    identityMap,
}: {
    state: DraftState;
    identityMap: Map<string, TemplateAccountIdentity>;
}): ChartOfAccountsTemplateAccountsBulkSave => {
    const groups: TemplateAccountGroupInput[] = state.groups.map((group) => ({
        id: group.id,
        name: group.name,
        type: group.type,
        parentGroupId: group.parentGroupId,
        sortOrder: group.sortOrder,
    }));
    const accounts: TemplateAccountInput[] = state.accounts.map((account) => {
        const identity = identityMap.get(account.id) ?? NULL_TEMPLATE_IDENTITY;
        return {
            id: account.id,
            codeText: account.codeText,
            kickOriginalCode: identity.kickOriginalCode,
            name: account.name,
            type: account.type,
            isDisabled: account.isDisabled,
            isManuallyCreated: account.isManuallyCreated,
            role: account.role ?? null,
            variableKind: identity.variableKind,
            form1099Box: account.form1099Box ?? null,
            parentGroupId: account.parentGroupId,
            sortOrder: account.sortOrder,
        };
    });
    return { groups, accounts };
};
